import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMetaTags } from "@/hooks/use-meta-tags";

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // The host answers unknown URLs with the SPA shell (HTTP 200), so this tag is
  // the only way to tell a JS-rendering crawler that this isn't a real page.
  useMetaTags({ robots: 'noindex, nofollow' });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{t('notFound.title')}</h1>
        <p className="mb-4 text-xl text-gray-600">{t('notFound.message')}</p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          {t('notFound.backHome')}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
